// Edit this file to update the welcome modal content.
// The welcome popup automatically shows again whenever the app or Tauri version changes.

export const welcomeConfig = {
  // News items shown at the top of the modal (HTML allowed)
  news: [
    '<strong>In-app documentation</strong> — browse and search the docs without leaving the designer.',
    '<strong>Script &amp; Flow editor</strong> — build visual node-based automation scripts for your plates.',
    '<strong>Right panel redesign</strong> — Pages, Outline and Properties now live in a clean tabbed panel.',
    '<strong>LVGL Themes</strong> — apply any of the built-in LVGL v7 themes to your design.',
    '<strong>Custom components</strong> — create, style and reuse your own components with an integrated icon editor.',
    '<strong>Snaplines &amp; rulers</strong> — pixel-perfect alignment with guides, snap-to-grid and snap-to-object.',
    '<strong>Improved HASS integration</strong> — redesigned YAML export and a new entity picker.',
    'HaspDesktop <strong>0.3.3</strong> is now available — download below for a native desktop experience.',
  ],

  // Desktop app downloads
  // url       — relative path served from the web server (files copied into dist/haspdesktop/ at build time)
  // externalUrl — absolute URL used when running inside the Tauri desktop app
  downloads: [
    {
      platform: 'Windows',
      label: 'Download for Windows (.exe)',
      url: '/haspdesktop/haspdesktop_0.3.3_x64-setup.exe',
      externalUrl: 'https://haspdesigner.qrisonline.nl/haspdesktop/haspdesktop_0.3.3_x64-setup.exe',
      icon: '🪟',
    },
    {
      platform: 'macOS',
      label: 'Download for macOS (.dmg)',
      url: '/haspdesktop/haspdesktop_0.3.3_aarch64.dmg',
      externalUrl: 'https://haspdesigner.qrisonline.nl/haspdesktop/haspdesktop_0.3.3_aarch64.dmg',
      icon: '🍎',
    },
  ],

  // Intro slides (shown below news)
  slides: [
    {
      imgSrc: 'media/doc/start_here.png',
      content: `
        <p>Start by creating a page, then add your components.</p>
        <p>Page&nbsp;0 is special — every object placed on it appears on all other pages.
           When you recreate Page&nbsp;0 make sure its id is set to&nbsp;0.</p>
      `,
    },
    {
      imgSrc: 'media/doc/hasp_start.png',
      content: `
        <p>Upload your images and use them in image components.</p>
      `,
    },
  ],
};
